/* Kalendarz — no handoff (owner, 17 October 2026). Every visual is `AccountScreen.module.css`'s;
 * this file only spaces the controls and sizes the skeleton.
 *
 * Every colour, space, radius and type value is a token; heights and widths are layout. */

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
  margin-top: var(--space-3);
}

/* The broken warning stands apart from the account lines above it. */
.brokenNote {
  margin-top: var(--space-3);
}

.retry {
  margin-top: var(--space-3);
}

/* The not-connected shape: one line of note, one button. */
.noteBar {
  display: block;
  width: 70%;
  height: var(--fs-micro);
}

.buttonBar {
  display: block;
  width: 96px;
  height: var(--h-account-button);
  margin-top: var(--space-3);
}
